import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
    AgentList, 
    AgentDetail, 
    AgentUpdate, 
    AgentSearchCriteria, 
    AgentCreate
} from '../../_models/agent.model';
import { ApiResponse } from '../../_models/api-response.model';
import { Page } from '../../_models/page.model';

@Injectable({
    providedIn: 'root'
})
export class AgentAdminService {
    private adminApiUrl = `${environment.apiUrl}/admin/agents`;

    constructor(private http: HttpClient) { }

    getAllAgents(
        criteria: AgentSearchCriteria = {},
        page: number = 0,
        size: number = 10,
        sort: string = 'createdAt',
        direction: string = 'DESC'
    ): Observable<ApiResponse<Page<AgentList>>> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString())
            .set('sort', sort)
            .set('direction', direction);

        if (criteria.search) {
            params = params.set('search', criteria.search);
        }
        if (criteria.isEnabled !== undefined) {
            params = params.set('isEnabled', criteria.isEnabled.toString());
        }
        if (criteria.isAvailable !== undefined) {
            params = params.set('isAvailable', criteria.isAvailable.toString());
        }
        if (criteria.specialization) {
            params = params.set('specialization', criteria.specialization);
        }
        if (criteria.minYearsExperience) {
            params = params.set('minYearsExperience', criteria.minYearsExperience.toString());
        }
        if (criteria.maxYearsExperience) {
            params = params.set('maxYearsExperience', criteria.maxYearsExperience.toString());
        }

        return this.http.get<ApiResponse<Page<AgentList>>>(this.adminApiUrl, { params });
    }

    getAgentDetails(agentId: number): Observable<ApiResponse<AgentDetail>> {
        return this.http.get<ApiResponse<AgentDetail>>(`${this.adminApiUrl}/${agentId}`);
    }

    createAgent(agentCreate: AgentCreate): Observable<ApiResponse<AgentDetail>> {
        return this.http.post<ApiResponse<AgentDetail>>(this.adminApiUrl, agentCreate);
    }

    updateAgent(agentId: number, agentUpdate: AgentUpdate): Observable<ApiResponse<AgentDetail>> {
        return this.http.put<ApiResponse<AgentDetail>>(
            `${this.adminApiUrl}/${agentId}`,
            agentUpdate
        );
    }

    updateAgentStatus(agentId: number, isAvailable: boolean): Observable<ApiResponse<void>> {
        const params = new HttpParams().set('isAvailable', isAvailable.toString());
        return this.http.patch<ApiResponse<void>>(
            `${this.adminApiUrl}/${agentId}/status`,
            {},
            { params }
        );
    }

    deleteAgent(agentId: number): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(`${this.adminApiUrl}/${agentId}`);
    }
}